import React, { useState, useCallback, useEffect } from 'react';
import EditInput from './components/EditInput';
import EditButton from '../../../common/EditIconButton';

const BulkEditor = ({ gridApi, handleEditInProgress, handleBulkUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);

  // UseCallback ensures the function reference remains stable
  const onGridSelectionChanged = useCallback(() => {
    if (!gridApi) return;
    const selectedRows = gridApi.getSelectedRows();
    setEnableEdit(selectedRows.length > 0);
  }, [gridApi]);

  useEffect(() => {
    if (gridApi) {
      gridApi.addEventListener('selectionChanged', onGridSelectionChanged);
      return () => {
        gridApi.removeEventListener('selectionChanged', onGridSelectionChanged);
      };
    }
  }, [gridApi, onGridSelectionChanged]);

  const toggleEditing = useCallback(
    (editing) => {
      if (!enableEdit && editing) return;
      setIsEditing(editing);
      handleEditInProgress?.(editing);
    },
    [handleEditInProgress, enableEdit]
  );

  return isEditing ? (
    <EditInput
      editMode={isEditing}
      exitEditMode={() => toggleEditing(false)}
      gridApi={gridApi}
      handleEditInProgress={handleEditInProgress}
      handleBulkUpdate={handleBulkUpdate}
    />
  ) : (
    <EditButton handleEdit={() => toggleEditing(true)} enableEdit={enableEdit} />
  );
};

export default BulkEditor;
